/**
 * Wrapper for DispatchTrailer when in pre-dispatch mode.
 * Injects handler-driven initial state and callbacks so DispatchTrailer stays
 * dispatch-only and all pre-dispatch flow lives in PreDispatchTrailerHandler.
 */
import React from "react";
import { PreDispatchTrailerDetailsSync } from "./PreDispatchTrailerDetailsSync";
import {
  getInitialTrailerDetails,
  getFirstTrailerFromSelection,
  getSuggestedTractorOnLoad,
  getSuggestedDollyOnLoad,
  computeUpdateState,
  normalizeDispatchPayload,
  shouldDisableRouteNameEdit,
  findDollyByLabel,
  isStartTimeEditable
} from "./preDispatchTrailerUtils";
import { withUserProfile } from "@withUserProfile";
import constants from "./constants";

const PreDispatchTrailerPanel = (props) => {
  const initialTrailerDetails = getInitialTrailerDetails(props);
  return (
    <PreDispatchTrailerDetailsSync
      key={initialTrailerDetails?.length ? initialTrailerDetails.map((trailer) => trailer.id).join(",") : "PreDispatchTrailerPanel"}
      {...props}
      isPreDispatch
      initialTrailerDetails={initialTrailerDetails}
      initialTractor={props.tractorList?.length ? getSuggestedTractorOnLoad({ tractorList: props.tractorList, selectedTractor: props.selectedTractor, initialTrailerDetails }) : null}
      getSuggestedTractorOnLoad={() => getSuggestedTractorOnLoad({ tractorList: props.tractorList, selectedTractor: props.selectedTractor, initialTrailerDetails })}
      getSuggestedDollyOnLoad={(trailerDetails, canShowDefaultDolly) =>
        getSuggestedDollyOnLoad(props, trailerDetails, canShowDefaultDolly)
      }
      computeUpdateState={(state, canShowDefaultDolly) =>
        computeUpdateState(state, props, canShowDefaultDolly)
      }
      normalizeDispatchPayload={(data) =>
        normalizeDispatchPayload(data, {
          allTrailers: props.allTrailers,
          terminalOffset: props.userData?.userProfile?.terminal?.offset,
        })
      }
      getRouteNameDisableEdit={(trailer, trailerIndex) => shouldDisableRouteNameEdit(trailer, props.selectedTrailer, trailerIndex)}
      getNewTrailerFromSelection={() => getFirstTrailerFromSelection(props.selectedTrailer, props.dollyList)}
      isStartTimeEditable={isStartTimeEditable}
      preDispatchIdealStartTimes={props.preDispatchIdealStartTimes}
      updateIdealStartTime={props.updateIdealStartTime}
      defaultDolly={findDollyByLabel(props.dollyList, constants.DEFAULT_DOLLY) ?? null}
    />
  );
};

export default withUserProfile(PreDispatchTrailerPanel);
